export default __webpack_public_path__ + "static/media/logo-any.a8b0c7e2.svg";